/* eslint-env es6, mode, browser */

import React, { memo, useMemo } from 'react'
// import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import {
  CHECKBOXES,
  DROPDOWN,
  LISTBOX,
  RADIOBUTTONS,
  HYBRID,
  RADIOBUTTONS_GRID,
  CHECKBOXES_GRID,
} from '../../../config'
import { compileText } from 'yatte'
import { GetDefaultSelectionStyle } from '../../../utils'
import DropDown from './dropdown'
import DropDownList from './dropdownlist'
import RadioList from './radiolist'
import RadioListFlex from './radiolistFlex'
import CheckList from './checklist'
import CheckListFlex from './checklistflex'
import ListBox from './listbox'
import Hybrid from './hybrid'
import HybridList from './hybridlist'
import { getKeyOfOpt } from './optionUtils'

const Selection = ({
                     id,
                     name,
                     label,
                     helpText,
                     style,
                     isList,
                     searchable,
                     options,
                     value,
                     context,
                     optionTemplate,
                     onChange,
                     unlabeled,
                     optionKeyName,
                     optFields,
                     cacheOpts,
                     topRecordId,
                     isInsideModal,
                   }) => {
  const getOptionTextFn = useMemo(() => {
    if (optionTemplate) {
      const evaluateOptionTemplate = compileText(optionTemplate)
      return (optObj, scope) => scope.evaluate(evaluateOptionTemplate)
    } else { // no option template; use key
      return (optObj, scope) => getKeyOfOpt(optObj, optionKeyName)
    }
  }, [optionTemplate, optionKeyName])

  // would be nice if the app compiler/definition told us more about the options, but it doesn't (currently) say much.
  // We need to figure out...
  // - is it an outright query? To find out, determine name of query:
  const optionQuery = useMemo(() => {
    const queryOrTable = options && context.getGlobalDef(options)
    if (queryOrTable && queryOrTable.provider && queryOrTable.source) { // it's a query
      // set up stuff here similar/parallel to SelectForms/index.js, where we use query and args
      // to fetch options asynchronously?
      return queryOrTable
    }
  }, [options])
  // If no query, evaluation is necessary:
  // - but does the evaluation depend on a query?  (else result of evaluation is available locally) -- not checked yet
  // - does the evaluation depend on the context/user data?  (else re-evaluation is NOT necessary) -- not checked yet
  // - what specific parts of the context must be watched?  -- not checked yet
  // Current/evaluated/"runtime" options (rtOptions) cannot be effectively memoized without the above checks,
  // because options MAY rely on some other part of the scope that hasn't necessarily changed!
  const rtOptions = useMemo(
    () => optionQuery ? undefined : context.getVarOptions(name)
    /* [!!optionQuery, name, context.scope] */)

  if (unlabeled) {
    helpText = null
    label = null
  }
  const renderStyle = style || GetDefaultSelectionStyle(isList)

  switch (renderStyle) {
    case DROPDOWN:
      if (isList) {
        return (
          <DropDownList id={id}
                        name={name}
                        label={label}
                        helpText={helpText}
                        searchable={searchable}
                        isList={isList}
                        value={value}
                        context={context}
                        rtOptions={rtOptions}
                        optionQuery={optionQuery}
                        optFields={optFields}
                        onChange={onChange}
                        optionKeyName={optionKeyName}
                        getOptionTextFn={getOptionTextFn}
                        isInsideModal={isInsideModal}
          />
        )
      }
      return (
        <DropDown id={id}
                  name={name}
                  label={label}
                  helpText={helpText}
                  searchable={searchable}
                  isList={isList}
                  value={value}
                  context={context}
                  rtOptions={rtOptions}
                  optionQuery={optionQuery}
                  optFields={optFields}
                  onChange={onChange}
                  optionKeyName={optionKeyName}
                  getOptionTextFn={getOptionTextFn}
                  isInsideModal={isInsideModal}
        />
      )
    case RADIOBUTTONS:
    case CHECKBOXES:
      if (isList) {
        return (
          <CheckList id={id}
                     name={name}
                     label={label}
                     helpText={helpText}
                     value={value}
                     context={context}
                     rtOptions={rtOptions}
                     optionQuery={optionQuery}
                     optFields={optFields}
                     onChange={onChange}
                     optionKeyName={optionKeyName}
                     getOptionTextFn={getOptionTextFn}
          />
        )
      } else { // !isList
        return (
          <RadioList id={id}
                     name={name}
                     label={label}
                     helpText={helpText}
                     renderStyle={renderStyle}
                     value={value}
                     context={context}
                     rtOptions={rtOptions}
                     optionQuery={optionQuery}
                     optFields={optFields}
                     onChange={onChange}
                     optionKeyName={optionKeyName}
                     getOptionTextFn={getOptionTextFn}
          />
        )
      }
    case RADIOBUTTONS_GRID:
    case CHECKBOXES_GRID:
      if (isList) {
        return (
          <CheckListFlex id={id}
                         name={name}
                         label={label}
                         helpText={helpText}
                         value={value}
                         context={context}
                         rtOptions={rtOptions}
                         optionQuery={optionQuery}
                         optFields={optFields}
                         onChange={onChange}
                         optionKeyName={optionKeyName}
                         getOptionTextFn={getOptionTextFn}
          />
        )
      } else {
        return (
          <RadioListFlex id={id}
                         name={name}
                         label={label}
                         helpText={helpText}
                         renderStyle={renderStyle}
                         value={value}
                         context={context}
                         rtOptions={rtOptions}
                         optionQuery={optionQuery}
                         optFields={optFields}
                         onChange={onChange}
                         optionKeyName={optionKeyName}
                         getOptionTextFn={getOptionTextFn}
          />
        )
      }
    case LISTBOX:
      return (
        <ListBox id={id}
                 name={name}
                 label={label}
                 helpText={helpText}
                 isList={isList}
                 value={value}
                 context={context}
                 rtOptions={rtOptions}
                 optionQuery={optionQuery}
                 optFields={optFields}
                 onChange={onChange}
                 optionKeyName={optionKeyName}
                 getOptionTextFn={getOptionTextFn}
        />
      )
    case HYBRID:
      if (isList) {
        return (
          <HybridList id={id}
                      name={name}
                      label={label}
                      helpText={helpText}
                      value={value}
                      context={context}
                      rtOptions={rtOptions}
                      optionQuery={optionQuery}
                      optFields={optFields}
                      onChange={onChange}
                      optionKeyName={optionKeyName}
                      getOptionTextFn={getOptionTextFn}
                      topRecordId={topRecordId}
                      isInsideModal={isInsideModal}
          />
        )
      } else {
        return (
          <Hybrid id={id}
                  name={name}
                  label={label}
                  helpText={helpText}
                  value={value}
                  context={context}
                  rtOptions={rtOptions}
                  optionQuery={optionQuery}
                  optFields={optFields}
                  onChange={onChange}
                  optionKeyName={optionKeyName}
                  getOptionTextFn={getOptionTextFn}
                  topRecordId={topRecordId}
                  isInsideModal={isInsideModal}
          />
        )
      }
    default:
      return null
  }
}

Selection.propTypes = {
  style: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isList: PropTypes.bool.isRequired,
  searchable: PropTypes.bool,
  isInsideModal: PropTypes.bool,
  options: PropTypes.string.isRequired,
  value: PropTypes.any,
  optionTemplate: PropTypes.string,
  localScope: PropTypes.any,
  onChange: PropTypes.func.isRequired,
}

// function areEqual(prevProps, nextProps) {
//   /*
//   return true if passing nextProps to render would return
//   the same result as passing prevProps to render,
//   otherwise return false
//   */
// }

export default memo(Selection) //, areEqual)
